import { render, staticRenderFns } from "./filedescription.vue?vue&type=template&id=f218608c&scoped=true"
import script from "./filedescription.vue?vue&type=script&lang=js"
export * from "./filedescription.vue?vue&type=script&lang=js"
import style0 from "./filedescription.vue?vue&type=style&index=0&id=f218608c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f218608c",
  null
  
)

export default component.exports